import BaseComponent from '@/components/base';
import SubscribeDetailsCardStyle from '@/components/subscription-details-card/style';
import RechargeGateway from '@/gateway/Recharge';

export default class SubscriptionDetailsCard extends BaseComponent {
  render() {
    return `
        ${SubscribeDetailsCardStyle()}
        <div class="card-details-container">
          <p class="canceled">Canceled</p>
          <div class="date-information">
            <p class="date">${this.date}</p>
            <p class="frequency-badge">Every ${this.frequency} Months</p>
          </div>
          <p>${this.address}</p>
          <div class="resubscribe-container">
            <button class="button-resubscribe" id="resubscribe">RESUBSCRIBE</button>
            <p class="edit-link-container">OR <a href=${
              this.urlEditSubscription
            } class="edit-link" id="edit"><u>EDIT SUBSCRIPTION</u></a></p>
          </div>
        </div>

        <modal-component enabled="false" modal-width="600px" id="modal-price-update">
          <div class="modal-container">
            <h2 class="modal-title">Price Update.</h2>
            ${this.modalText}
            <button class="cta-button" id="price-update-cta">GOT IT</button>
          </div>
        </modal-component>

        <modal-component enabled="false" modal-width="600px" id="modal-skin-update">
          <div class="modal-container">
            <h2 class="modal-title">${this.modalTitleSkin}</h2>
            ${this.modalTextSkin}
            <button class="cta-button" id="skin-update-cta">GOT IT</button>
          </div>
        </modal-component>`;
  }

  connectedCallback() {
    this.connectButtonEvents();
  }

  connectButtonEvents() {
    //variable to validate if has shampoo or conditioner with 8 or 16 oz
    let hasShampooOrConditioner = false;
    let productsIsntSkin = [];

    async function handleResubscribe() {
      const urlParams = new URLSearchParams(window.location.search);
      const subscriptions = urlParams.get('subscriptions');
      let subsciptionsArray = JSON.parse(subscriptions);
      if (productsIsntSkin.length > 0) {
        subsciptionsArray = productsIsntSkin.map((subscription) => {
          return subscription.id;
        });
      }
      await RechargeGateway.updateReactiveSubscritions(subsciptionsArray, true);
    }

    async function handleShowModal() {
      const modalComponent = this.shadowRoot.querySelector(
        '#modal-price-update'
      );
      modalComponent.enabled = true;
    }

    async function handleShowModalSkin() {
      const modalComponent =
        this.shadowRoot.querySelector('#modal-skin-update');
      modalComponent.enabled = true;
    }

    async function handleGetProductsInfo() {
      const urlParams = new URLSearchParams(window.location.search);
      const subscriptions = urlParams.get('subscriptions');
      const subsciptionsArray = JSON.parse(subscriptions);
      const allSubscriptionsObjects =
        await RechargeGateway.getSubscriptionsArray(subsciptionsArray);

      const hasSkinProduct = allSubscriptionsObjects.some((subscription) => {
        const profileType = subscription.properties.find(
          (prop) => prop.name === '__profile_type'
        );
        return profileType && profileType.value === 'skin';
      });
      productsIsntSkin = allSubscriptionsObjects.filter((subscription) => {
        const profileType = subscription.properties.find(
          (prop) => prop.name === '__profile_type'
        );
        return profileType && profileType.value !== 'skin';
      });

      hasShampooOrConditioner = allSubscriptionsObjects.some(
        (sub) =>
          (sub.sku.includes('conditioner') || sub.sku.includes('shampoo')) &&
          (sub.sku.includes('8oz') || sub.sku.includes('16oz'))
      );
      if (hasShampooOrConditioner) {
        await handleShowModal.call(this);
      } else if (hasSkinProduct) {
        await handleShowModalSkin.call(this);
      } else {
        await handleResubscribe();
      }
    }

    const resubscribeButton = this.shadowRoot.querySelector('#resubscribe');
    resubscribeButton.addEventListener(
      'click',
      handleGetProductsInfo.bind(this)
    );

    // Price update modal events
    const priceUpdateModal = this.shadowRoot.querySelector(
      '#modal-price-update'
    );
    const priceUpdateCta = this.shadowRoot.querySelector('#price-update-cta');

    priceUpdateCta.addEventListener('click', () => {
      priceUpdateModal.enabled = false;
    });

    // Skin update modal events
    const skinUpdateModal = this.shadowRoot.querySelector('#modal-skin-update');
    const skinUpdateCta = this.shadowRoot.querySelector('#skin-update-cta');

    skinUpdateCta.addEventListener('click', async () => {
      skinUpdateModal.enabled = false;
      if (productsIsntSkin.length > 0) {
        await handleResubscribe();
      }
    });
  }

  get date() {
    return this.getAttribute('date');
  }

  get frequency() {
    const urlString = window.location.href;
    const url = new URL(urlString);
    return url.searchParams.get('frequency');
  }

  get modalText() {
    let text = this.getAttribute('popupText');
    let popupLink = this.getAttribute('popupLink');
    let label = this.getAttribute('popupLinkLabel');

    let container = document.createElement('div');
    if (!container) return text;

    container.innerHTML = text;
    let lastParagraph = container.querySelector('p:last-of-type');

    if (!lastParagraph) return text;

    let link = `<a href=${popupLink} class="edit-link" target="_blank"><u><b>${label}</b></u></a>`;
    lastParagraph.innerHTML += ' ' + link;
    text = container.innerHTML;
    return text;
  }

  get modalTextSkin() {
    let text = this.getAttribute('popupTextSkin');
    let popupLink = this.getAttribute('popupLinkSkin');
    let label = this.getAttribute('popupLinkLabelSkin');

    let container = document.createElement('div');
    if (!container) return text;

    container.innerHTML = text;
    let lastParagraph = container.querySelector('p:last-of-type');

    if (!lastParagraph) return text;

    let link = `<a href=${popupLink} class="edit-link" target="_blank"><u><b>${label}</b></u></a>`;
    lastParagraph.innerHTML += ' ' + link;
    text = container.innerHTML;
    return text;
  }

  get modalTitleSkin() {
    let title = this.getAttribute('popupTitleSkin');
    return title;
  }

  get address() {
    const addressString = this.getAttribute('address');

    const parts = addressString.split('<br>');

    const number = parts[2].trim();
    const street = parts[1].trim();
    const cityStateAndZip = parts[3].trim();

    const cityStateAndZipParts = cityStateAndZip.split(' ');

    let city, state, zipcode;
    if (cityStateAndZipParts.length === 4) {
      city = cityStateAndZipParts[0] + ' ' + cityStateAndZipParts[1];
      state = cityStateAndZipParts[2];
      zipcode = cityStateAndZipParts[3];
    } else {
      city = cityStateAndZipParts[0];
      state = cityStateAndZipParts[1];
      zipcode = cityStateAndZipParts[2] ? cityStateAndZipParts[2] : '';
    }

    let addressFormatted = `${number} ${street}, ${city}, ${state}, ${zipcode}`;

    if (addressFormatted.endsWith(', ')) {
      addressFormatted = addressFormatted.slice(0, -2);
    }
    return addressFormatted;
  }

  get urlEditSubscription() {
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptions = urlParams.get('subscriptions');
    return `/collections/configuration?editing=1&subscriptions=${subscriptions}&cancelled=1`;
  }
}
